import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,ProfilActionButton,EditModalActionButton,Loading,DeleteActionButton,ColumDataTableReorganize,CreateSupplementList,useLocalStorage} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory from 'react-bootstrap-table2-editor';
import axios from 'axios'
import swal from "sweetalert2"
import Moment from 'react-moment';
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Modal } from "react-bootstrap";

const useLoad = () => {
    const t = useTranslate();
    const [allSupplementList,setAllSupplementList]=useState([])
    const [sizeDatas,setSizeDatas]=useState(0)
    const [loading,setLoading]=useState(true)
    const [perPage,setPerPage]=useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [reloadData,setReloadData] = useState(Date.now())

    useEffect(function () {
        (async function() {
            const response  = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/all/"+perPage+"/"+currentPage,
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{
                    setAllSupplementList(response.data.datas)
                    setSizeDatas(response.data.count)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [reloadData])
    
    return [loading,allSupplementList,setAllSupplementList,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage,setReloadData]
} 

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={paginationFactory(props.paginationOptions)}
            onTableChange={ props.handleTableChange }
            noDataIndication={t('tableNoData')}
            cellEdit={ cellEditFactory({ 
                mode: 'dbclick', 
                blurToSave: true,
            }) }
            defaultSortDirection={props.defaultSortDirection}
            hover
            condensed
            responsive
        />
    );
};

const ItemsSupplementListTable = (props) => {
    const t = useTranslate();

    const [loading,allSupplementList,setAllSupplementList,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage,setReloadData]=useLoad()
    

    const [cookies, setCookie] = useCookies(['supplement_list_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['supplement_list_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.supplement_list_reorganize && cookies.supplement_list_reorganize){
            setLocalStorage('supplement_list_reorganize',cookies.supplement_list_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [showModalCreateSupplementList,setShowModalCreateSupplementList]=useState(false) 

    // Modal edit
    const [modalEditId,setModalEditId]=useState(false) 

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const deleteListeArticle = async (supplementListDetailId) => {
        const response  = await axios.delete(process.env.REACT_APP_API_URL+"api/erp/supplement_list/"+supplementListDetailId
        ).then((response) => {
            let updateList = allSupplementList.filter(value=>value.id!=supplementListDetailId)
            setAllSupplementList(updateList)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    let datas = new Array
    allSupplementList.forEach((value,ind)=>{

        let obj = {
            name: value.name,
            id:value.id,
            multiple_choice:(value.multiple_choice) ? t('btnYes') : t('btnNo'),
            required_choice:(value.required_choice) ? t('btnYes') : t('btnNo'),
            order:value.order,
            created_at: <Moment format="DD/MM/YYYY">{value.created_at}</Moment>,
            action: 
                <span className="d-flex justify-content-between">
                    <ProfilActionButton path={'/erp/supplement-list-detail/'+value.id}/> 
                    <EditModalActionButton hisId={value.id} setModalEditId={setModalEditId} setShowEdit={setShowModalCreateSupplementList} />
                    <DeleteActionButton deleteFunctionArgument={value.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={value.name} customClickEvent={deleteListeArticle}/>
                </span>,
            index:ind
        }
        datas.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };

    let columns = [
        {
            dataField: "action",
            text: 'Actions',
            editable: false,
        },
        {
            dataField: "name",
            text: t('tableName'),
            editable: false,
            sort: false,
        },
        {
            dataField: "multiple_choice",
            text: t('multiple_choice'),
            editable: false,
            sort: false,
        },
        {
            dataField: "required_choice",
            text: t('required_choice'),
            editable: false,
            sort: false,
        },
        {
            dataField: "order",
            text: t('priority'),
            editable: false,
            sort: false,
        },
        {
            dataField: "created_at",
            text: t('createdAt'),
            editable: false,
            sort: false,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.supplement_list_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.supplement_list_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("supplement_list_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder}) => {

        setPerPage(sizePerPage)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/all/"+sizePerPage+"/"+page
            ).then((response) => {
                setAllSupplementList(response.data.datas)
                setSizeDatas(response.data.count)
                setCurrentPage(page)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
    }

    const onCloseModal = () => {
        setShowModalCreateSupplementList(false)
        setModalEditId(false)
    }
    
    if(loading){
        return (<Loading></Loading>);
    }
    return (<>
        <CardPerso header={
            <>
                {t('supplementList')}&nbsp;&nbsp;
                <button className="btn btn-success btn-sm" onClick={() => setShowModalCreateSupplementList('createSupplementList')}><FontAwesomeIcon icon={faPlus} /></button>
            </>
        }>
            <Modal show={showModalCreateSupplementList} onHide={() => onCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('supplementList')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateSupplementList 
                        setShow={setShowModalCreateSupplementList} 
                        show={showModalCreateSupplementList} 
                        setReloadData={setReloadData} 
                        modalEditId={modalEditId} //Pour l'édition
                        setModalEditId={setModalEditId}

                        allSupplementList={allSupplementList} 
                        setAllSupplementList={setAllSupplementList} 
                    />
                </Modal.Body>
            </Modal>
            <div className="row mb-3">
                <div className="col-2">
                    <ColumDataTableReorganize 
                        columnOrganize={columnOrganize}
                        setColumnOrganize={setColumnOrganize}
                        setCookie={setLocalStorage}
                        cookieName='supplement_list_reorganize'
                        showColumnOrganize={showColumnOrganize}
                        setShowColumnOrganize={setShowColumnOrganize}
                        btnSwitch={false}//pour affiche ou non le btn swith
                        initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                    />&nbsp;&nbsp;&nbsp;
                </div>
            </div>
            <small>
                <ToolkitProvider
                keyField="index"
                data={datas}
                columns={columnOrganize}
                >
                {(propst) => (
                    <>
                        <div className="position-relative">
                            <CustomDataTable 
                                propst={propst}
                                paginationOptions={paginationOptions}
                                columns={columns}
                                handleTableChange={handleTableChange}
                                defaultSortDirection="asc"
                            />
                        </div>
                    </>
                )}
                </ToolkitProvider>
            </small>
        </CardPerso>
    </>);
}

export default ItemsSupplementListTable;
